module.exports = __webpack_public_path__ + "img/5-yon-helmi.607bba63.jpg";